module.exports = __webpack_public_path__ + "img/huananzhiwuyuan.a8191e99.png";